import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import "../assets/storeDashboard/dashboard.css";
import { getUserData } from "../utils/localStorage";
import { getStoreOrderDashboard } from "../services/DashboardAPI/DashboardApi";
import { formatDate, localeDateEndDate, localeDateStartDate } from "../constants/DateUtil/DateUtil";
import { useNavigate } from "react-router-dom";
import AddNewCustomer from "./AddNewCustomer/AddNewCustomer";
import StoreMenu from "./StoreMenu";
import TabMenu from "./TabMenu";
import { getWarehouseDashboardQrCode } from "../services/warehouse/Warehouse";
import { getWarehouseGarmentsByStatus } from "../services/warehouse/WarehouseProcess";
import TabMenuWarehouse from "./TabMenuWarehouse";
import { SubscriptionExpiryAlert } from "./ExpiredSoon";

const { innerWidth: width, innerHeight: height } = window;

const backgroundImages = [
  "Laundy_App_Icons_Gifs/Home_Page/Delivery.png",
  "Laundy_App_Icons_Gifs/Home_Page/Pickup.png",
  "Laundy_App_Icons_Gifs/Home_Page/Today_bookings.png",
  "Laundy_App_Icons_Gifs/Home_Page/Reprocess.png",
  "Laundy_App_Icons_Gifs/Home_Page/Rider_delivery.png",
  "Laundy_App_Icons_Gifs/Home_Page/Pending_orders.png",
  "Laundy_App_Icons_Gifs/Home_Page/Delivery.png",
];

const WarehouseDashboard = () => {
  const navigate = useNavigate();

  const { userProfileData, storeData, warehouseData } = getUserData();
  const warehouseId = warehouseData.id;
  let enabledAutoUnProcess = warehouseData.enabledAutoUnProcess;
  let enabledGarmentProcessStage = warehouseData.enabledGarmentProcessStage;
  const subscriptionExpiryDate = userProfileData.nextRenewalOn;

  const base64String = `data:image/png;base64,${warehouseData.logo}`;
  const [addNewCustomerModalVisible, setAddNewCustomerModalVisible] =
    useState(false);

  const [dashboardData, setDashboardData] = useState([]);
  const [visible, setVisible] = useState(false);

  const [challanInTimeData, setChallanInTimeData] = useState([]);
  const [challanOutTimeData, setChallanOutTimeData] = useState([]);
  const [challanOrderOnData, setChallanOrderOnData] = useState([]);
  const [receivedAndReadyData, setReceivedAndReadyData] = useState([]);
  const [receivedButNotReadyData, setReceivedButNotReadyData] = useState([]);
  const [unProcessedData, setUnProcessedData] = useState([]);

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const arrayResult = enabledAutoUnProcess
    ? [
        {
          id: 0,
          name: "Received From Store",
          challan: challanInTimeData,
          challanLength: challanInTimeData.length,
          backgroundImages: backgroundImages[0],
        },
        {
          id: 1,
          name: "Sent To Store",
          challan: challanOutTimeData,
          challanLength: challanOutTimeData.length,
          backgroundImages: backgroundImages[1],
        },
        {
          id: 2,
          name: "Processed On",
          challan: challanOrderOnData,
          challanLength: challanOrderOnData.length,
          backgroundImages: backgroundImages[2],
        },
        {
          id: 3,
          name: "UnProcessed",
          challan: unProcessedData,
          challanLength: unProcessedData.length,
          backgroundImages: backgroundImages[3],
        },
        {
          id: 4,
          name: "Received And Ready",
          challan: receivedAndReadyData,
          challanLength: receivedAndReadyData.length,
          backgroundImages: backgroundImages[5],
        },
        {
          id: 5,
          name: "Received But Not Ready",
          challan: receivedButNotReadyData,
          challanLength: receivedButNotReadyData.length,
          backgroundImages: backgroundImages[4],
        },
        {
          id: 6,
          name: "Order Status",
          challan: null,
          challanLength: null,
          backgroundImages: backgroundImages[1],
        },
      ]
    : [
        {
          id: 0,
          name: "Received From Store",
          challan: challanInTimeData,
          challanLength: challanInTimeData.length,
          backgroundImages: backgroundImages[0],
        },
        {
          id: 1,
          name: "Sent To Store",
          challan: challanOutTimeData,
          challanLength: challanOutTimeData.length,
          backgroundImages: backgroundImages[1],
        },
        {
          id: 2,
          name: "Processed On",
          challan: challanOrderOnData,
          challanLength: challanOrderOnData.length,
          backgroundImages: backgroundImages[2],
        },
        {
          id: 4,
          name: "Received And Ready",
          challan: receivedAndReadyData,
          challanLength: receivedAndReadyData.length,
          backgroundImages: backgroundImages[5],
        },
        {
          id: 5,
          name: "Received But Not Ready",
          challan: receivedButNotReadyData,
          challanLength: receivedButNotReadyData.length,
          backgroundImages: backgroundImages[4],
        },
        {
          id: 6,
          name: "Order Status",
          challan: null,
          challanLength: null,
          backgroundImages: backgroundImages[1],
        },
      ];

  const onSelectCardItem = (id) => {
    if (id === 0) {
      navigate("/WarehouseDashboardQrCodeList", {
        state: {
          recordType: "IN_TIME",
        },
      });
    } else if (id === 1) {
      navigate("/WarehouseDashboardQrCodeList", {
        state: {
          recordType: "OUT_TIME",
        },
      });
    } else if (id === 2) {
      navigate("/WarehouseDashboardQrCodeList", {
        state: {
          recordType: "PROCESSED_ON",
        },
      });
    } else if (id === 3) {
      navigate("/WarehouseDashboardQrCodeList", {
        state: {
          recordType: "UNPROCESSED",
        },
      });
    } else if (id === 4) {
      navigate("/WarehouseDashboardQrCodeListReceivedReady", {
        state: {
          recordType: "PROCESSED",
        },
      });
    } else if (id === 5) {
      navigate("/WarehouseDashboardQrCodeListReceivedReady", {
        state: {
          recordType: "IN_PROCESS",
        },
      });
    }  else if (id === 6) {
        navigate("/WarehouseOrderStatus", {
          state: {
            recordType: "IN_PROCESS",
          },
        });
    } else {
      navigate("/");
    }
  };

  const filteredData = arrayResult
  .filter((item) => enabledGarmentProcessStage || item.id !== 6)


  const renderDashboardCards = () => {
    return filteredData.map((item) => {
      return (
        <div
          key={item.name}
          className="relative overflow-hidden"
          onClick={() => onSelectCardItem(item.id, item.storeOrderByStatus)}
          style={{ cursor: "pointer" }}
        >
          <img
            className="h-12rem w-13rem"
            src={item.backgroundImages}
            alt={item.name}
          />
          <div
            className="absolute py-2 pl-3 border-round-xs"
            style={{
              top: "1%",
            }}
          >
            <p className="text-white text-4xl font-bold uppercase">
              {item.challanLength}
            </p>
            <p className="text-white text-xl font-bold uppercase">
              {item.name}
            </p>

            <p className="text-white text-lg font-bold uppercase ">
              {[0, 1, 2, 3].includes(item.id) &&
                startDate.toLocaleString("en-US", {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                  hour12: true,
                })}
            </p>
          </div>
        </div>
      );
    });
  };

  useEffect(() => {
    const requestInTimeData = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      recordType: "IN_TIME",
    };
    const requestOutTimeData = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      recordType: "OUT_TIME",
    };
    const requestOrderOnData = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      recordType: "PROCESSED_ON",
    };

    const receivedAndReady = {
      status: ["PROCESSED"],
    };

    const UNPROCESSED = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      status: ["UNPROCESSED"],
    };

    const receivedButNotReady = {
      status: ["IN_PROCESS"],
    };
    getWarehouseDashboardQrCode(warehouseId, requestInTimeData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setChallanInTimeData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    getWarehouseDashboardQrCode(warehouseId, requestOutTimeData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setChallanOutTimeData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    getWarehouseDashboardQrCode(warehouseId, requestOrderOnData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setChallanOrderOnData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    getWarehouseDashboardQrCode(warehouseId, UNPROCESSED)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setUnProcessedData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getWarehouseGarmentsByStatus(warehouseId, receivedAndReady)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setReceivedAndReadyData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getWarehouseGarmentsByStatus(warehouseId, receivedButNotReady)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setReceivedButNotReadyData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }, []);

  return (
    <div className="flex-1">
      <div
        className="h-8rem border-round-bottom surface-0 sticky z-1 top-0"
        style={{
          "--border-radius": "50px",
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex flex-row ml-3 mr-3 pt-2">
          <div className="flex-1 flex flex-row">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div
                className="h-4rem w-4rem border-circle bg-white flex justify-content-center align-items-center cursor-pointer"
                onClick={() => navigate("/UserProfile")}
              >
                {warehouseData.logo ? (
                  <img
                    style={{ width: "35px" }}
                    src={base64String}
                    alt="logo"
                  />
                ) : (
                  <img
                    style={{ width: "35px" }}
                    src="/warehouse/warehouse_5.png"
                    alt="logo"
                  />
                )}
              </div>
            </div>
            <div className="flex-1 ml-3">
              <p className="text-white text-xl font-bold uppercase">
                {userProfileData.firstName.replace(/_/g, " ")}{" "}
                {userProfileData.lastName.replace(/_/g, " ")}
              </p>
              <p className="text-white text-base font-bold uppercase">
                Manager - {warehouseData.name.replace(/_/g, " ")}
              </p>
              <p className="text-white text-sm font-light">
                <img
                  style={{ width: "10px", marginRight: 5 }}
                  src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Location.png"
                  alt="logo"
                />
                {warehouseData.address.addressLine1 +
                  " " +
                  warehouseData.address.addressLine2 +
                  " " +
                  warehouseData.address.city +
                  " " +
                  warehouseData.address.state}
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer mr-5"
            onClick={() => navigate("Logout")}
          >
            <i
              className="pi pi-power-off"
              onClick={() => navigate("/")}
              style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="flex" style={{ marginBottom: 100 }}>
        <div className="px-0 ml-5 mr-5 relative flex-1 mt-5">
          <div className="formgroup-inline gap-4">{renderDashboardCards()}</div>
        </div>
      </div>
      <SubscriptionExpiryAlert expiryDate={subscriptionExpiryDate} />
      <TabMenuWarehouse />
    </div>
  );
};

export default WarehouseDashboard;

// import { Button } from 'primereact/button';
// import React from 'react'
// import { useLocation, useNavigate } from 'react-router-dom';

// const WarehouseDashboard = () => {
//   const navigate = useNavigate();
//   const handleBackButton = () => {
//     navigate('/logout');
//   }
//   return (
//     <div className='flex flex-1 justify-content-center '>
//       <div className='flex flex-column justify-content-center align-items-center'>
//         <img
//           src={'VectorsLaundryApp/DhobiCart.png'}
//           style={{
//             width:   400,

//           }}
//         />
//         <p className='text-3xl font-medium'>WareHouse Feature is Coming Soon</p>
//         <p className='text-3xl font-medium'>Please User Store Only</p>
//         <Button
//                   className="mt-3 mb-3 mx-4 border-round-xl flex-1 "
//                   onClick={handleBackButton}
//                 >
//                   <p className=" w-full text-2xl font-semibold flex justify-content-center">
//                     Back To Dhobi cart
//                   </p>
//                 </Button>
//       </div>
//     </div>
//   )
// }

// export default WarehouseDashboard
